import styled from "styled-components";
import colors from "../../constants/colors";

export const SlotItem = styled("div")<{
  $isLast?: boolean;
}>(({ $isLast }) => ({
  borderBottom: $isLast ? "none" : `1px solid ${colors.GREY_3}`,
  paddingBlock: "0.5rem",
  backgroundColor: colors.WHITE,
  display: "flex",
  flexDirection: "column",
  gap: "0.375rem",
}));

export const SlotContentWrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const SlotInfo = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.1875rem",
  alignItems: "flex-start",
  flex: 1,
});

export const CustomerNamePhone = styled("span")({
  fontSize: "0.8125rem",
  fontWeight: 600,
  color: colors.BLACK,
  lineHeight: 1.2,
});

export const ServicePriceDescription = styled("span")({
  fontSize: "0.75rem",
  fontWeight: 500,
  color: colors.GREY_7,
  lineHeight: 1.2,
});

export const SlotWhen = styled(ServicePriceDescription)({});
